import { appendImagesEvidence } from "./scene-evidence-parts/append-images";
import { animateEvidence } from "./scene-evidence-parts/animate-evidence";

export function sceneEvidence() {
  if ($(".scene-evidence").length) {
    $(".scene-evidence").empty();
    appendImagesEvidence();

    animateEvidence();
  }
}
